export const qk = {
	adminPortalConfig: () => ['adminPortalConfig'],
	theme: () => ['theme'],
	projectWidgets: () => ['projectWidgets'],
	featureFlags: () => ['featureFlags']
};

export const API_ROUTES = {
	projectWidgets: () => '/v1/widgets',
	adminPortalConfig: (projectId: string) =>
		`/${projectId}/adminportal/apconfig.json`,
	theme: (projectId: string, styleId: string) =>
		`/${projectId}/v2-beta/${styleId}.json`,
	authorized: () => '/v1/authorized',
	featureFlags: () => '/v1/featureflags'
};
